import { useState } from "react";

export default function Submenu({ icon, title, items, defaultOpen, active }) {
  const [open, setOpen] = useState(defaultOpen || false);

  return (
    <li className="submenu">
      <a
        href="javascript:void(0);"
        className={`${active ? "active" : ""} ${open ? "subdrop" : ""}`}
        onClick={() => setOpen(!open)}
      >
        <i className={icon}></i>
        <span>{title}</span>
        <span className="menu-arrow"></span>
      </a>

      {open && (
        <ul>
          {items.map((item, index) =>
            item.submenu ? (
              <li className="submenu submenu-two" key={index}>
                <a href="#">
                  {item.label}
                  <span className="menu-arrow inside-submenu"></span>
                </a>
                <ul>
                  {item.submenu.map((sub, subIndex) => (
                    <li key={subIndex}>
                      <a href={sub.link}>{sub.label}</a>
                    </li>
                  ))}
                </ul>
              </li>
            ) : (
              <li key={index}>
                <a className={item.active ? "active" : ""} href={item.link}>
                  {item.label}
                </a>
              </li>
            )
          )}
        </ul>
      )}
    </li>
  );
}
